import { usePostHog } from "posthog-js/react";
import { useRef } from "react";

export function useTrackCourseSelected() {
  const posthog = usePostHog();
  const once = useRef(false);

  const trackCourseSelected = () => {
    if (once.current) return;
    once.current = true;
    posthog.capture("course_selected");
  };

  return trackCourseSelected;
}
